/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Event_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Event Group" |
*
* @param {Drastic_Tech_Event_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_event_group_label = /** @type {((inputs?: Drastic_Tech_Event_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Event_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos")
	return /** @type {LocalizedString} */ ("Event Group")
});